import { useMemo } from "react";
import { usePermission } from "@/auth/session-provider";
import type { NavigationGroup, NavigationItem } from "./navigation-model";

/** 按当前会话的权限过滤菜单项；未声明 permissions 的项对所有登录用户可见。 */
export function useVisibleNavigationItems(items: NavigationItem[]): NavigationItem[] {
  const { canAny } = usePermission();

  return useMemo(() => items.filter((item) => !item.permissions?.length || canAny(...item.permissions)), [items, canAny]);
}

/** 同上，并丢掉过滤后为空的分组，避免留下光秃秃的分组标题。 */
export function useVisibleNavigationGroups(groups: NavigationGroup[]): NavigationGroup[] {
  const { canAny } = usePermission();

  return useMemo(
    () =>
      groups
        .map((group) => ({
          ...group,
          items: group.items.filter((item) => !item.permissions?.length || canAny(...item.permissions)),
        }))
        .filter((group) => group.items.length > 0),
    [groups, canAny],
  );
}
